var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.054.463 1.6 3.339 3.55.521c.3.053.4.418.2.679L8.854 7.61l.6 3.653c.05.313-.25.573-.5.417l-3.2-1.722-3.2 1.722c-.25.156-.55-.104-.5-.417l.6-3.653-2.55-2.608c-.2-.209-.1-.574.2-.626l3.55-.522 1.6-3.34c.1-.312.5-.312.6-.051"
  })));
};
export default SvgStar;